module.exports = __webpack_public_path__ + "static/media/logo.6a38f479.svg";